import { environment } from '@environments/environment';

export const GET_LAYOUTS_FILTER_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_models ?? '',
  body: {
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'implantation',
            },
          },
        ],
      },
    },
    _source: ['name'],
    from: 0,
    size: 10000,
  },
});
